<template>
  <div class="container_mapper">
    <div v-for="(message, index) in MessageArray" :key="index" class="container_mapper_item">
      <QuestionList v-if="message.type == 'select'" :message="message" @sendMessageBack="getMessage" />
      <!-- <ChatbotQA v-else-if="message.type == 'qa'" :message="message" :last-item="message.lastItem" /> -->
      <ChatbotQA v-else-if="message.type == 'qa'" :message="message" :last-item="MessageArray.indexOf(message) == MessageArray.length - 1" />
      <OtherQA v-else-if="message.type === 'other'" :message="message" />
      <Top3QaRecommend v-else-if="message.type === 'Top3QaRecommend'" :title="message.title" />
      <ChatbotService v-else-if="message.type === 'ChatbotService'" />
      <ChatbotWelcome v-else-if="message.type === 'Welcome'" :message="message.title" />
    </div>
  </div>
</template>

<script>
import QuestionList from "@/components/QuestionList";
import ChatbotQA from "@/components/ChatbotQA";
import OtherQA from "@/components/OtherQA";
import Top3QaRecommend from '@/components/Top3QaRecommend'
import ChatbotService from '@/components/Service'
import ChatbotWelcome from '@/components/Welcome'

export default {
  components: {
    QuestionList,
    ChatbotQA,
    OtherQA,
    Top3QaRecommend,
    ChatbotService,
    ChatbotWelcome,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    MessageArray() {
      return this.messageList;
    },
  },
  methods: {
    getMessage(value) {
      this.$emit("sendMessageBack", value);
    },
  },
  props: {
    messageList: Array,
  },
};
</script>

<style scoped>

</style>
